<template>
  <input
    @input="returnInput"
    type="text"
    class="donation-input-field w-input"
    :class="input_class"
    maxlength="256"
    :value="initial_value"
    :placeholder="placeholder"
    ref="field"
  />
</template>

<script>
export default {
  props: ["placeholder", "input_class", "initial_value"],
  methods: {
    returnInput() {
      this.$emit("return", this.$refs.field.value)
    },
  },
}
</script>

<style scoped>
.donation-input-field::placeholder {
  text-transform: capitalize;
  font-family: "Open Sans", sans-serif;
}
</style>
